import React from 'react';

import { loggedInUserDataStore } from '../../../../shared/stores/loggedInUserDataStore';
import { nutritionRegistrationService } from '../../../../auth-management/services/registrationService/nutritionRegistrationService';
import { RegistrationFormAccessWidget } from '../../../../auth-management/components/RegistrationFormAccessWidget/RegistrationFormAccessWidget';
import { NgzRegistrationFormStyleWidget } from '../../entity-profile/containers/NgzRegistrationFormStyleWidget/NgzRegistrationFormStyleWidget';

const NutritionRegistrationTab = () => {
  const entityId = loggedInUserDataStore.getEntityId();

  return (
    <div>
      <RegistrationFormAccessWidget
        id={entityId}
        getRegistrationLink={nutritionRegistrationService.getRegistrationLink}
        getRegistrationQrCode={nutritionRegistrationService.getRegistrationQrCode}
        qrCodeDescription="A QR code has already been generated and assigned to your entity"
      />
      <NgzRegistrationFormStyleWidget entityId={entityId} />
    </div>
  );
};

export { NutritionRegistrationTab };
